module.exports = {"530923101":"德党镇","530923102":"小勐统镇","530923103":"永康镇","530923203":"勐板乡","530923204":"亚练乡","530923205":"乌木龙乡","530923206":"大雪山乡","530923207":"班卡乡","530923208":"崇岗乡","530923209":"大山乡","530923401":"勐底农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530923.json
// module id = 2418
// module chunks = 0